// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G4_n","top":"styles_top__1AjCS","left":"styles_left__Dzpts","description":"styles_description__10iAi"};